<ion-content class="app organisation">
  <div>
    <app-loader [loading]="!customerLoaded" [full]="true"></app-loader>
    <ng-container *ngIf="customerLoaded">
      <div class="organisation__header" role="banner">
        <div>
          <span class="back-button">
            <ion-back-button defaultHref="/" mode="md"></ion-back-button>
          </span>
        </div>
        <div class="organisation__header__info">
          <div
            class="organisation__image"
            *ngIf="customer.logoThumbnails?.full"
          >
            <img
              [src]="customer.logoThumbnails?.full"
              alt="{{ customer.name }}"
            />
          </div>
          <div class="organisation__info">
            <h1>{{ customer.name }}</h1>
            <div class="organisation__info__followers">
              {{ (amountOfFollowers === 1 ? 'project.home.followers.singular' :
              'project.home.followers.plural') | translate:{'followers':
              amountOfFollowers} }}
            </div>
            <div>
              {{ 'organisation.detail.member-since' | translate }} {{
              customer.createdAt | date:'d MMMM yyyy' }}
            </div>
          </div>
        </div>
        <div
          role="navigation"
          #tabs
          class="tabs"
          [class.sticky]="sticky"
          *ngIf="pages"
        >
          <ion-segment
            scrollable
            (ionChange)="segmentChanged($event)"
            [value]="currentPage"
          >
            <ion-segment-button
              tabindex="0"
              tab="page.value"
              role="tab"
              [attr.aria-selected]="currentPage === page.value"
              [class]="page.value"
              *ngFor="let page of pages"
              [value]="page.value"
            >
              <span
                aria-hidden="true"
                *ngIf="page.unread"
                class="notification-dot"
              ></span>
              {{ page.title | translate }}
            </ion-segment-button>
          </ion-segment>
        </div>
      </div>
      <div class="organisation__content">
        <app-organisation-home
          [hidden]="currentPage !== 'home'"
          [customer]="customer"
          [latestUpdate]="latestUpdate"
          [language]="language"
          (switchTab)="switchTab($event)"
        >
        </app-organisation-home>
        <app-organisation-about-us
          [customer]="customer"
          [language]="language"
          [hidden]="currentPage !== 'about-us'"
        >
        </app-organisation-about-us>
        <app-organisation-projects
          [customer]="customer"
          [hidden]="currentPage !== 'projects'"
        >
        </app-organisation-projects>
        <app-update-list
          [updates]="updates"
          [customer]="customer"
          [hidden]="currentPage !== 'updates'"
          [updateDeviceData]="updateDeviceData"
        >
        </app-update-list>
      </div>
    </ng-container>
  </div>
</ion-content>
